import React, { Context, createContext } from 'react';

import { NOOP } from '@testsigma/atoms';

import { Agent } from '@models/agent.model';

export interface ReportAgentContextProps {
  uniqueAgents: Agent[];
  setUniqueAgents: React.Dispatch<React.SetStateAction<Agent[]>>;
  testPlanIdVsAgents: Record<string, Agent[]>;
  setTestPlanIdVsAgents: React.Dispatch<
    React.SetStateAction<Record<string, Agent[]>>
  >;
}

export const ReportAgentContext: Context<ReportAgentContextProps> =
  createContext<ReportAgentContextProps>({
    uniqueAgents: [],
    setUniqueAgents: NOOP,
    testPlanIdVsAgents: {},
    setTestPlanIdVsAgents: NOOP,
  });
